import { translations } from '../../../translations'

export const EditOrdersModal = {
  icon: 'pencil-outline',
  title: translations.pt_PT.Modal.titleEditOrder,
  footerBtn: 'saveBtn',
  component: 'editOrders'
}



// WEBPACK FOOTER //
// ./src/skeletons/structures/setup/editOrdersModal.js